export default __webpack_public_path__ + "static/media/66t.c57ea1ee.jpg";